const MEASUREMENT_ID = 'G-J22RKH44EY';

const gtag = (...args) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag(...args);
};

export const trackPageView = ({ path, title }) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const setAnalyticsUser = (userId) => {
  gtag('config', MEASUREMENT_ID, {
    user_id: userId || null,
    send_page_view: false,
  });
};

export const trackEvent = (name, params = {}) => {
  gtag('event', name, params);
};
